import { render, staticRenderFns } from "./FooterModel.vue?vue&type=template&id=2bd22acd&scoped=true"
import script from "./FooterModel.vue?vue&type=script&lang=js"
export * from "./FooterModel.vue?vue&type=script&lang=js"
import style0 from "./FooterModel.vue?vue&type=style&index=0&id=2bd22acd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd22acd",
  null
  
)

export default component.exports